import Swiper from './swiper-bundle.js';

theme.ProductblockSection = (function() {
  var selectors = {
    swiperBtn: 'subsection__button',
    swiperNextEl: 'subsection-first__button',
    swiperPrevEl: 'subsection-last__button',
    swiperContainer: '.productblock-swiper'
  };
  

  function ProductblockSection(container) {
    var sectionId = container.dataset.sectionId;

    this.container = container;
    this.swiperContainer = this.container.querySelector(selectors.swiperContainer);
    this.nextEl = this.container.getElementsByClassName(selectors.swiperNextEl);
    this.prevEl = this.container.getElementsByClassName(selectors.swiperPrevEl);
    this.btn = this.container.getElementsByClassName(selectors.swiperBtn);

    const swipershow = new Swiper(this.swiperContainer, {
        allowTouchMove: false,
        loop: false,
        autoplay: false,
        autoHeight: true
    });

    const _this = this;
    
    for (let i = 0; i < this.btn.length; i ++) {
      this.btn[i].onclick = function() {
        document.querySelectorAll('.subsection__button').forEach(v => {
          v.classList.remove('active');
        });
        swipershow.slideTo(i, 300);
        _this.btn[i].classList.add('active');
      }
    }

  }

  return ProductblockSection;
})();

theme.ProductblockSection.prototype = Object.assign(
  {},
  theme.ProductblockSection.prototype,
  {
    
  }
);

document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();

  sections.register('productblock-section', theme.ProductblockSection);

  theme.customerTemplates.init();
});